




















import { defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
  name: "OccAlert",
  props: {
    iconName: {
      type: String,
      default: ""
    },
    type: {
      type: String as PropType<"success" | "warning" | "danger">,
      default: "danger",
      validator: function(value: string) {
        return ["success", "warning", "danger"].includes(value);
      }
    },
    mainTextList: {
      type: Array as PropType<string[]>,
      default: ""
    }
  },
  setup() {}
});
